import React from 'react';
import { Link } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';

export default function MobileNavigationMenu({ base_url, navigate }) {
    const [anchorMobile, setAnchorMobile] = React.useState(null);

    const handleClick = (event) => {
        setAnchorMobile(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorMobile(null);
    };

  return (
      <div style={{ float: 'right' }}>
        <IconButton aria-controls="mobile_navigation" aria-haspopup="true" onClick={handleClick}>
            <MenuIcon/>
        </IconButton>
        <Menu
            id="mobile_navigation"
              anchorEl={anchorMobile}
              keepMounted
              open={Boolean(anchorMobile)}
              onClose={handleClose}>
              <MenuItem><Link onClick={() => navigate("Sart.org")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>Back to Sart.org</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("Search")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>Back to Search</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("About")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>About</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("Patients")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>Patients</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("IVFInfo")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>IVF Info</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("IVFSuccess")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>IVF Success</Link></MenuItem>              
              <MenuItem><Link onClick={() => navigate("Professionals")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>Professionals And Providers</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("MemberLogin")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>Member Login</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("MemberResources")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>Member Resources</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("JoinSART")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>Join SART</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("2022Data")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>2022 National Summary Data</Link></MenuItem>
              <MenuItem><Link onClick={() => navigate("2023Data")} style={{ textDecoration: "none", textTransform: "none", color: "#42738D" }}>2023 Preliminary National Data</Link></MenuItem>
        </Menu>
    </div>
  );
}